module.exports = __webpack_public_path__ + "img/tianlan.ec355ea1.jpeg";